import React, { useState, useCallback, useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
// @ts-ignore
import { useYouTube } from '@njmyers/react-you-tube';
import Cookies from 'js-cookie';
import App from './App';
// @ts-ignore
import RoomPage from './RoomPage';
// @ts-ignore
import Billboard from './Billboard';
// @ts-ignore
import Chart from './Chart';
// @ts-ignore
import Privacy from './Privacy';
// @ts-ignore
import Terms from './Terms';
import './index.css';
import './styles/threshold.css';

import ReactGA from 'react-ga4';
import mixpanel from 'mixpanel-browser';

mixpanel.init('0b97a4d6eae669ee8c34f24be75b65b6');
ReactGA.initialize('G-X6Q5K6QRH6');

const modeToId: Record<string, string> = {
  lofi: 'rFZHOHl-L8A',
  study: 'rFZHOHl-L8A',
  focus: 'mg7netw1JuM',
  white: 'LD92VXIl8hc',
  forest: 'GwIO1nzuJrw',
  silent: 'kvO_nHnvPtQ',
};

interface YouTubePlayer {
  cueVideoById: (id: string, startSeconds?: number, quality?: string) => void;
  loadVideoById: (id: string, startSeconds?: number, quality?: string) => void;
  playVideo: () => void;
  pauseVideo: () => void;
  stopVideo: () => void;
  setVolume: (volume: number) => void;
  getPlayerState: () => number;
}

const AppWithYouTube: React.FC = () => {
  const [node, setNode] = useState<HTMLDivElement | null>(null);
  const handleRef = useCallback((node: HTMLDivElement | null) => {
    if (node !== null) {
      setNode(node);
    }
  }, []);

  const savedMode = Cookies.get('mode');
  const initializeWithYoutube = savedMode === 'youtube' && Cookies.get('youtube');

  const videoId = initializeWithYoutube
    ? Cookies.get('youtube') || modeToId.lofi
    : modeToId[savedMode || 'lofi'];

  const player = useYouTube(node, {
    width: 640,
    height: 390,
    videoId: videoId,
    playerVars: {
      autoplay: 0,
      controls: 1,
      playlist: videoId,
      loop: 1,
      wMode: 'transparent',
      start: 1,
    },
  }) as YouTubePlayer | null;

  const loadSong = useCallback((mode: string) => {
    const id = Object.keys(modeToId).includes(mode) ? modeToId[mode] : mode;
    player?.cueVideoById(id, 0, 'small');
  }, [player]);

  useEffect(() => {
    if (player) {
      console.info('[Main] YouTube player ready');
    }
  }, [player]);

  return (
    <>
      {/* Hidden YouTube player element */}
      <div
        style={{
          position: 'fixed',
          bottom: 0,
          right: 0,
          opacity: 0,
          width: '1px',
          height: '1px',
          pointerEvents: 'none',
        }}
        ref={handleRef}
        id="player"
      />
      {/* Play trigger for mobile */}
      <div
        style={{
          position: 'absolute',
          opacity: 0,
          pointerEvents: 'none',
          width: 0,
          height: 0,
        }}
        onClick={() => {
          if (player?.playVideo && player?.pauseVideo) {
            player.pauseVideo();
            player.playVideo();
          }
        }}
        id="play-root"
      />
      <BrowserRouter>
        <Routes>
          <Route path="/billboard" element={<Billboard />} />
          <Route path="/chart" element={<Chart />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/room/:roomId" element={<RoomPage player={player} />} />
          <Route path="/enter/:worldId" element={<App player={player} loadSong={loadSong} />} />
          <Route path="/*" element={<App player={player} loadSong={loadSong} />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <AppWithYouTube />
  </React.StrictMode>
);
